module.exports = __webpack_public_path__ + "media/images/photo/about_deal-af2e72c833f986f12cb78a883255bb39.png";